<script setup>
defineProps({
    title: {
        type: [String, Boolean],
        default: '',
    },
    subtitle: {
        type: String,
        default: '',
    },
    reserveSubtitle: {
        type: Boolean,
        default: false,
    },
    padded: {
        type: Boolean,
        default: false,
    },
    short: {
        type: Boolean,
        default: false,
    },
    showAllLink: {
        type: [Object, Boolean],
        default: () => null,
    },
    showAllTitle: {
        type: String,
        default: 'show all',
    },
})
</script>

<template>
    <section
        :class="[
            'base-section',
            padded ? 'base-section-padded' : '',
            short ? 'base-section-short' : '',
        ]"
    >
        <div
            v-if="title || subtitle || reserveSubtitle"
            class="title-row"
        >
            <h5 class="title">{{ title }}</h5>
            <slot name="right" />
            <router-link
                v-if="showAllLink"
                :to="showAllLink"
                class="link"
            >
                {{ showAllTitle }} <BaseIcon
                    class="icon-arrow-right"
                    name="arrow-right"
                />
            </router-link>
            <div
                v-if="subtitle || reserveSubtitle"
                :class="['subtitle', !subtitle ? 'subtitle-reserved' : '']"
            >{{ subtitle }}</div>
        </div>
        <slot />
    </section>
</template>

<style lang="scss" scoped>
@import '@design';

.base-section {
    margin-top: $size-grid-padding * 3;

    &-short {
        margin-top: 0;
    }

    @include tablet {
        margin-top: 0;

        @include container;
    }

    &-padded {
        @include sidePadding;
    }
}
.base-section + .base-section {
    margin-top: $size-grid-padding * 3;

    @include desktop {
        margin-top: $s-h;
    }
}

.title {
    @include heading;

    margin: 0;
}

.subtitle {
    @extend %secondary;

    min-width: 100%;
    margin: 0;

    &-reserved {
        visibility: hidden;
        min-height: 20px;
    }
}

.title-row {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    justify-content: space-between;
    margin-top: 0;
    margin-bottom: $size-large-grid-padding;

    .link {
        @extend %contentTextButton;

        .icon-arrow-right {
            width: 14px;
            height: 11px;
            margin-left: $s-s;
            vertical-align: middle;
            color: $c-highlight;
        }
    }
}
</style>
